export default __webpack_public_path__ + "static/media/gmail.183fcfc4.svg";